export default function() {
  // REST API
  // Usage example:
  // api('/instrument?symbol=AAPL.OQ')
  //   .then( (res) => {
  //     console.log(res)
  //   })
  if (!window.api) {
    window.api = function(route, _opts) {
      let opts = _opts || {}
      opts.headers = opts.headers || {}
      opts.headers["Authorization"] = (window.user ? window.user.token : localStorage.token)
      if (opts.method && (opts.method.toLowerCase() == 'post' || opts.method.toLowerCase() == 'put'))
          opts.headers["Content-Type"] = 'application/json'
      return fetch(window.API_ENDPOINT+route, opts)
        .then((response) => {
          if (response.status == 401) {
            window.location = "/login";
            return
          }
          if (response.status > 400 && response.status != 409) {
            var error = new Error(response.statusText)
            error.message = 'Server Panic: Please contact support.'
            console.log(response)
            throw error
          }
          return response.json()
        })
    }
  }

  // Realtime websocket API
  // Usage example:
  // realtime().then( (socket) => {
  //   socket.onjson = (m) {
  //     if (!(m.symbol)) return
  //     // tasks...
  //   }
  //   socket.subscribe("service.Heartbeat.>")
  // }).catch( (err) => { console.log(err) })
  if (!window.realtime) {
    window.realtime = function() {
      return new Promise((resolve, reject) => {
          let url = window.API_ENDPOINT.replace("http:", "ws:").replace("https:", "wss:")
          if (window.API_ENDPOINT.indexOf("http") !== 0) {
            url = location.protocol+"//"+location.hostname
            if (location.port != "") url += ":" + location.port
            url += window.API_ENDPOINT
            url = url.replace("http:", "ws:").replace("https:", "wss:")
          }
          url += "/realtime?authToken=" + (window.user ? window.user.token : localStorage.token).replace("Bearer ","")
          let socket = new WebSocket(url);
          socket.onopen = function (event) {
            socket.subscribe = function(topic, args) {
              args = args || {}
              args.op = 'subscribe'
              args.topic = topic
              socket.send(JSON.stringify(args))
            }
            socket.unsubscribe = function(topic, args) {
              args = args || {}
              args.op = 'unsubscribe'
              args.topic = topic
              socket.send(JSON.stringify(args))
            }
            socket.onmessage = (m) => {
                if (m.data === "🥓") {
                  if (socket.__lastPingAt) {
                    socket.__latency = (+ new Date) - socket.__lastPingAt
                    console.log('socket: latency = ', socket.__latency)
                    try {
                      localStorage.socketLatency = socket.__latency
                    } catch(e) {}
                  }
                  return
                }
              try {
                let message = JSON.parse(m.data)
                if (socket.onjson) socket.onjson(message)
              } catch(e) { console.log("malformed websocket frame",e, m); return; }
            }
            //treo api ping pong
            let _tmrPingPong = setInterval(() => {
              try {
                socket.send(JSON.stringify({op:"🐷"}))
                socket.__lastPingAt = +(new Date)
              } catch(e) {
                clearInterval(_tmrPingPong)
              }
            }, 30000)

            resolve(socket)
          }
          socket.onerror = function (e) {
            reject(e)
          }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api.jsx